export const grade = ['369 466',`
 <g xmlns="http://www.w3.org/2000/svg">
 <g xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
 <g>
     <g>
         <path d="M256,246c-5.52,0-10,4.48-10,10s4.48,10,10,10s10-4.48,10-10C266,250.48,261.52,246,256,246z"/>
     </g>
 </g>
 <g>
     <g>
         <path d="M256,326c-5.52,0-10,4.48-10,10c0,5.52,4.48,10,10,10s10-4.48,10-10C266,330.48,261.52,326,256,326z"/>
     </g>
 </g>
 <g>
     <g>
         <path d="M256,409c-5.52,0-10,4.48-10,10c0,5.52,4.48,10,10,10s10-4.48,10-10C266,413.48,261.52,409,256,409z"/>
     </g>
 </g>
 <g>
     <g>
         <path d="M445.982,92.654c-0.006-0.184-0.011-0.368-0.028-0.551c-0.014-0.16-0.038-0.316-0.059-0.474    c-0.023-0.165-0.044-0.329-0.075-0.493c-0.031-0.166-0.071-0.327-0.11-0.49c-0.037-0.154-0.074-0.307-0.118-0.459    c-0.047-0.161-0.102-0.318-0.156-0.476c-0.052-0.151-0.105-0.302-0.165-0.451c-0.061-0.151-0.128-0.297-0.196-0.444    c-0.069-0.15-0.138-0.299-0.215-0.446c-0.074-0.142-0.155-0.279-0.236-0.416c-0.084-0.143-0.167-0.287-0.259-0.427    c-0.091-0.139-0.19-0.273-0.288-0.407c-0.094-0.129-0.186-0.258-0.286-0.383c-0.115-0.143-0.238-0.277-0.36-0.413    c-0.078-0.087-0.148-0.179-0.229-0.264l-80-83c-0.022-0.023-0.046-0.041-0.068-0.064c-0.131-0.133-0.27-0.257-0.407-0.382    c-0.108-0.099-0.214-0.202-0.325-0.295c-0.125-0.105-0.259-0.199-0.39-0.298c-0.132-0.1-0.261-0.205-0.397-0.297    c-0.116-0.079-0.24-0.147-0.359-0.221c-0.156-0.097-0.311-0.199-0.471-0.286c-0.132-0.072-0.27-0.131-0.405-0.197    c-0.154-0.075-0.307-0.157-0.464-0.224c-0.175-0.074-0.357-0.134-0.537-0.199c-0.123-0.044-0.244-0.096-0.369-0.135    c-0.182-0.057-0.37-0.1-0.557-0.147c-0.129-0.032-0.256-0.072-0.386-0.099c-0.163-0.034-0.33-0.055-0.495-0.081    c-0.16-0.025-0.319-0.056-0.48-0.073c-0.144-0.016-0.291-0.019-0.437-0.029c-0.187-0.012-0.374-0.027-0.562-0.028    C356.06,0.004,356.031,0,356,0H96C79.458,0,66,13.458,66,30v452c0,16.542,13.458,30,30,30h320c16.542,0,30-13.458,30-30V93    C446,92.883,445.987,92.77,445.982,92.654z M366,34.785L412.472,83H376c-5.514,0-10-4.486-10-10V34.785z M426,482    c0,5.514-4.486,10-10,10H96c-5.514,0-10-4.486-10-10V30c0-5.514,4.486-10,10-10h250v53c0,16.542,13.458,30,30,30h50V482z"/>
     </g>
 </g>
 <g>
     <g>
         <path d="M203.071,228.928c-3.906-3.905-10.236-3.905-14.142,0.001L156,261.858l-12.929-12.929c-3.906-3.905-10.236-3.905-14.143,0    c-3.905,3.905-3.905,10.237,0,14.143l20,20C150.882,285.024,153.44,286,156,286s5.118-0.976,7.071-2.929l40-40    C206.976,239.166,206.976,232.834,203.071,228.928z"/>
     </g>
 </g>
 <g>
     <g>
         <path d="M376,246h-80c-5.522,0-10,4.477-10,10s4.478,10,10,10h80c5.522,0,10-4.477,10-10S381.522,246,376,246z"/>
     </g>
 </g>
 <g>
     <g>
         <path d="M203.071,308.928c-3.906-3.905-10.236-3.905-14.142,0.001L156,341.858l-12.929-12.929c-3.906-3.905-10.236-3.905-14.143,0    c-3.905,3.905-3.905,10.237,0,14.143l20,20C150.882,365.024,153.44,366,156,366s5.118-0.976,7.071-2.929l40-40    C206.976,319.166,206.976,312.834,203.071,308.928z"/>
     </g>
 </g>
 <g>
     <g>
         <path d="M376,326h-80c-5.522,0-10,4.477-10,10s4.478,10,10,10h80c5.522,0,10-4.477,10-10S381.522,326,376,326z"/>
     </g>
 </g>
 <g>
     <g>
         <path d="M203.071,391.928c-3.906-3.905-10.236-3.905-14.142,0.001L156,424.858l-12.929-12.929c-3.906-3.905-10.236-3.905-14.143,0    c-3.905,3.905-3.905,10.237,0,14.143l20,20C150.882,448.024,153.44,449,156,449s5.118-0.976,7.071-2.929l40-40    C206.976,402.166,206.976,395.834,203.071,391.928z"/>
     </g>
 </g>
 <g>
     <g>
         <path d="M376,409h-80c-5.522,0-10,4.477-10,10s4.478,10,10,10h80c5.522,0,10-4.477,10-10S381.522,409,376,409z"/>
     </g>
 </g>
 <g>
     <g>
         <path d="M225.285,169.286l-16.067-40.166c-0.002-0.006-0.004-0.012-0.007-0.017l-23.927-59.816C183.767,65.489,180.089,63,176,63    s-7.767,2.489-9.285,6.286l-23.927,59.816c-0.002,0.006-0.005,0.012-0.007,0.017l-16.067,40.166    c-2.05,5.129,0.444,10.948,5.572,13c5.126,2.052,10.946-0.443,12.999-5.571L158.771,143h34.459l13.485,33.714    c1.564,3.91,5.319,6.289,9.288,6.289c1.236,0,2.493-0.23,3.711-0.718C224.842,180.234,227.336,174.414,225.285,169.286z     M166.77,123L176,99.926L185.229,123H166.77z"/>
     </g>
 </g>
 <g>
     <g>
         <path d="M276,83h-10V73c0-5.523-4.478-10-10-10c-5.522,0-10,4.477-10,10v10h-10c-5.522,0-10,4.477-10,10s4.478,10,10,10h10v10    c0,5.523,4.478,10,10,10c5.522,0,10-4.477,10-10v-10h10c5.522,0,10-4.477,10-10S281.522,83,276,83z"/>
     </g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 </g>
 </g>
`]